<template>
  <div>
    <PublicLayout>
      <header
        class="header"
        :style="{
          backgroundImage: `url(${require('@/assets/public/images/contribution/header.jpg')})`,
        }"
      >
        <div class="container">
          <h1>社会貢献</h1>
        </div>
      </header>
      <!-- main-section -->
      <section class="main-section">
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary text-center">
              「對未來的投資」是富地滋的社會貢獻活動。
            </h2>
            <p>
              富地滋作為「健康創造企業」，在舉辦民眾參與的學術研討會等活動的同時，也致力於社會貢獻活動。
              <br />
              身為企業不僅是創造利益、納稅，還要致力於改善我們所生活的社會。
              <br />
              這也是對企業來說重要的社會責任之一。 <br />
              其中，對於支援必要物資給予需要的人，是其中一種較為直接的方式。
              <br />
              然而，這個方法只能暫時性解決，治標不治本。 <br />
              為了在那裡生活的人們，我們應該做什麼？我們能做什麼呢？ <br />
              富地滋的活動是為了創造更好的未來，我們從感受、思考、行動開始。
            </p>
          </div>
        </section>
        <!-- m-sec end -->
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary text-center">
              創造人們可以生活的環境
            </h2>
            <p>
              這是對我們未來的投資。
              今後富地滋將超越所謂企業活動與社會貢獻兩者稱之的「CSR」(企業的社會責任)，朝「CSV」(Creating
              Shared
              Value=創造共享價值)為目標邁進，致力於解決社會課題和健康創造事業。
            </p>
          </div>
        </section>
        <!-- m-sec end -->
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
export default {
  name: "ContributionScreen",
  components: {
    PublicLayout,
  },
};
</script>